// String formatting utilities — extracted from MyScripts/Utils.ts

import { hasStringValue } from './validation';
import { cleanArray } from './arrays';
import moment from 'moment-timezone';

export function capitalizeFirstLetter(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function convertCentsToFormattedDollars(cents: number): string {
  if (cents == null) {
    return '';
  }
  return (cents / 100).toLocaleString("en-US", { style: "currency", currency: "USD" });
}

export function getFormattedDisposition(callDispositionValue: string, dispositionNotes: string): string {
  if (!hasStringValue(callDispositionValue) && !hasStringValue(dispositionNotes)) {
    return "";
  }
  return cleanArray([callDispositionValue, dispositionNotes]).join(" - ");
}

export function getLastChar(str: string): string {
  return str.substr(str.length - 1);
}

export function getInsecureUUID(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

export function kstTimeUTCToDisplayTimeLocalTime(kstTimeValue: number): string {
  const maxKstTimeValue: number = 1000 * 60 * 60 * 24;
  const millisecondsInAMinute: number = 1000 * 60;
  const kstTimeValueLocal = ((moment.tz(moment.utc(), moment.tz.guess()).utcOffset() * millisecondsInAMinute + kstTimeValue) + maxKstTimeValue) % maxKstTimeValue;
  const minutesInAnHour: number = 60;
  const totalMinutes: number = Math.floor(kstTimeValueLocal / millisecondsInAMinute);
  const hour: number = Math.floor(totalMinutes / minutesInAnHour);
  const minute: number = totalMinutes % minutesInAnHour;
  const hourDisplay = (hour < 10 ? `0${hour}` : hour);
  const minuteDisplay = (minute < 10 ? `0${minute}` : minute);
  return `${hourDisplay}:${minuteDisplay}`;
}

export function displayKstTimeFromTourTimeZoneToLocalTimeZone(kstTimeValue: number, timeZoneLocal: string): string {
  const maxKstTimeValue: number = 1000 * 60 * 60 * 24;
  const millisecondsInAMinute: number = 1000 * 60;
  const sourceOffset = moment.tz(moment.utc(), timeZoneLocal).utcOffset();
  const targetOffset = moment.tz(moment.utc(), moment.tz.guess()).utcOffset();
  const offsetDifference = (targetOffset - sourceOffset) * millisecondsInAMinute;
  const kstTimeValueLocal = ((offsetDifference + kstTimeValue) + maxKstTimeValue) % maxKstTimeValue;
  const minutesInAnHour: number = 60;
  const totalMinutes: number = Math.floor(kstTimeValueLocal / millisecondsInAMinute);
  const hour: number = Math.floor(totalMinutes / minutesInAnHour);
  const minute: number = totalMinutes % minutesInAnHour;
  const hourDisplay = (hour < 10 ? `0${hour}` : hour);
  const minuteDisplay = (minute < 10 ? `0${minute}` : minute);
  return `${hourDisplay}:${minuteDisplay}`;
}
